var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGermany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.625H24V10.875H0V5.625Z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 0H3.75C1.26488 0 0 1.84688 0 4.125V5.625H24V4.125C24 1.84688 22.7351 0 20.25 0Z",
    fill: "#25333A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.375C0 14.6531 1.26488 16.5 3.75 16.5H20.25C22.7351 16.5 24 14.6531 24 12.375V10.875H0V12.375Z",
    fill: "#F9CB38"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermany);
export default __webpack_public_path__ + "static/media/germany.a8647dc8fe662cc81895f9d94e9807fb.svg";
export { ForwardRef as ReactComponent };